import * as React from "react";
import { Box, Typography } from "@mui/material";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTooltip
} from "@progress/kendo-react-charts";
import "hammerjs";

const StackedGroupChart = ({ bar1Color, bar2Color, color, data, legendText1, legendText2 }) => {
  const sx = {
    container: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingY: "20px",
      gap: "5px",
      span: {
        color: "darkBlue.c100"
      }
    }
  };
  return (
    <Box>
      <Box sx={sx.container}>
        <Box sx={{ height: "12px", width: "12px", background: bar1Color }}></Box>
        <Typography variant="overline1">{`${legendText1}`.toLocaleUpperCase()}</Typography>
        <Box sx={{ height: "12px", width: "12px", background: bar2Color }}></Box>
        <Typography variant="overline1">{`${legendText2}`.toLocaleUpperCase()}</Typography>
      </Box>
      <Chart transitions={false}>
        <ChartValueAxis>
          <ChartValueAxisItem majorGridLines={true} color="#9292AF" font="Poppins" />
        </ChartValueAxis>
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            majorGridLines={false}
            categories={data.map((val) => val.month)}
            color="#9292AF"
            font="Poppins"
          />
        </ChartCategoryAxis>
        <ChartTooltip background={color} />
        <ChartSeries>
          <ChartSeriesItem
            gap={5}
            color={bar1Color}
            type="column"
            data={data.map((val) => val.receivedApplications)}
            markers={{
              visible: false
            }}
          />
          <ChartSeriesItem
            gap={5}
            color={bar2Color}
            type="column"
            data={data.map((val) => val.verifiedApplications)}
            markers={{
              visible: false
            }}
          />
        </ChartSeries>
      </Chart>
    </Box>
  );
};

export default StackedGroupChart;
